import { ExamsFilterRouteView } from "@features/exam";
/* -----------------Others--------------- */
import { Stack } from "expo-router";

const ExamsRoute = () => {
	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<ExamsFilterRouteView />
		</>
	);
};

export default ExamsRoute;
